import { fromJS } from 'immutable';

import {
  SET_OPENED_WITH_NOTIFICATION_ID,
  CLEAR_OPENED_WITH_NOTIFICATION_ID,
} from '../../actions/Notification';

const initialState = fromJS({ openedWithNotificationId: null });

export default function notification(state = initialState, action = {}) {
  switch (action.type) {
    case SET_OPENED_WITH_NOTIFICATION_ID:
      return state.set('openedWithNotificationId', action.notificationId);
    case CLEAR_OPENED_WITH_NOTIFICATION_ID:
      return state.set('openedWithNotificationId', null);
    default:
      return state;
  }
}
